export default __webpack_public_path__ + "static/front-7ded73fe7b0bde6548fab2eee05ac673.webp";